import { observer } from "mobx-react-lite";
import { ActivityDetailsItem } from "../../../ActivityDetailsItem/ActivityDetailsItem";
import { useActionDetails } from "../../hooks/useActionDetails";
import type { ActionGroupProps } from "../../types";
import { ActionDetailsContainer } from "../common/ActionDetailsContainer";
import { WithFindWrapper } from "../common/WithFindWrapper/WithFindWrapper";
import { RECORD_ID } from "../../../../../../../utils/constants";
import {
  addEmptyValueIfNeeded,
  findRecordValue,
} from "../../../../../ActivityGrid/ActivityGrid.helpers";
import { valueDataToString } from "@smartsuite/automation-conditions";
import { StyledDocsAutomatorLoopingGroup } from "./style";

export const DocsAutomatorLoopingGroup = observer<ActionGroupProps>(
  ({
    action,
    recordJobData,
    recordJobDataByDetailsId,
    recordJobIds,
    onRecordClick,
    onDetailsClick,
  }) => {
    const { status, errorMessage, actionLabel } = useActionDetails(action);

    return (
      <ActionDetailsContainer
        label={actionLabel}
        status={status}
        errorMessage={errorMessage}
        onDetailsClick={onDetailsClick}
      >
        <WithFindWrapper
          recordJobData={recordJobData}
          recordJobDataByDetailsId={recordJobDataByDetailsId}
          recordJobIds={recordJobIds}
          onRecordClick={onRecordClick}
        >
          {({ recordJobData }) => {
            const record =
              recordJobData?.outputData?.recordList?.recordList !== undefined
                ? recordJobData.outputData.recordList.recordList.records[0]
                : recordJobData?.record;

            const output = record?.outputs.find(
              (output) => output.outputId === RECORD_ID,
            );

            const tableIdInput = recordJobData?.inputs?.find(
              (input) => input.inputId === "application-id",
            );

            const solutionIdInput = recordJobData?.inputs?.find(
              (input) => input.inputId === "solution-id",
            );

            const docsAutomatorAutomationIdInput = recordJobData?.inputs?.find(
              (input) => input.inputId === "docsautomator_automation",
            );

            const pdfDocumentInput = recordJobData?.inputs?.find(
              (input) => input.inputId === "pdf_title",
            );

            const exportedPdfTitleOutput =
              recordJobData?.outputData?.outputs?.find(
                (output) => output.outputId === "exported-pdf-title",
              );

            const exportedPdfUrlOutput =
              recordJobData?.outputData?.outputs?.find(
                (output) => output.outputId === "exported-pdf-url",
              );

            let tableId = recordJobData === undefined ? "" : "<no value>";
            if (tableIdInput !== undefined) {
              tableId = valueDataToString(tableIdInput.value);
            }

            let solutionId = "<no value>";
            if (solutionIdInput !== undefined) {
              solutionId = valueDataToString(solutionIdInput.value);
            }

            let docsAutomatorAutomationId = "<no value>";
            if (docsAutomatorAutomationIdInput !== undefined) {
              docsAutomatorAutomationId = valueDataToString(
                docsAutomatorAutomationIdInput.value,
              );
            }

            let exportedPdfTitle = "<no value>";
            if (exportedPdfTitleOutput !== undefined) {
              exportedPdfTitle = valueDataToString(
                exportedPdfTitleOutput.value,
              );
            }

            let exportedPdfUrl = "<no value>";
            if (exportedPdfUrlOutput !== undefined) {
              exportedPdfUrl = valueDataToString(exportedPdfUrlOutput.value);
            }

            return (
              <StyledDocsAutomatorLoopingGroup>
                <ActivityDetailsItem label="Application ID">
                  {tableId}
                </ActivityDetailsItem>
                <ActivityDetailsItem label="Solution ID">
                  {solutionId}
                </ActivityDetailsItem>
                <ActivityDetailsItem label="DocsAutomator Automation ID">
                  {docsAutomatorAutomationId}
                </ActivityDetailsItem>
                <ActivityDetailsItem label="Pdf Document">
                  {exportedPdfUrl ? (
                    <a href={exportedPdfUrl} target="_blank" rel="noreferrer">
                      {exportedPdfTitle}
                    </a>
                  ) : (
                    <span>{exportedPdfTitle}</span>
                  )}
                </ActivityDetailsItem>
                {output !== undefined && (
                  <ActivityDetailsItem label={output.outputLabel}>
                    {addEmptyValueIfNeeded(
                      findRecordValue(output.outputId, record),
                    )}
                  </ActivityDetailsItem>
                )}
              </StyledDocsAutomatorLoopingGroup>
            );
          }}
        </WithFindWrapper>
      </ActionDetailsContainer>
    );
  },
);
